import { useContext } from "react";
import { ConfigurationContext } from "@utils/ConfigurationProvider";

/**
 * Event names the BFF renders in a feed ("general" or "aiSuggested"), from /api/configuration.
 * Null until loaded, or when the BFF does not publish them, which means "no filter".
 */
export function useActivityFeedEventNames(kind = "general") {
  const { config } = useContext(ConfigurationContext) ?? {};
  const names = config?.activityFeedEventNames?.[kind];
  return Array.isArray(names) && names.length > 0 ? names : null;
}
